import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    position: "sticky",
    top: "0",
    display: props.matches ? "flex" : "none",
    justifyContent: "space-between",
    alignItems: "center",
    height: "3rem",
    padding: "0 7rem",
    zIndex: 2,
    backgroundColor: theme.darkSlateGrayColor,
  }),
  linkContainer: {
    cursor: "pointer",
    "& > a": {
      padding: "1rem",
      fontSize: "0.9rem",
      textDecoration: "none",
      textTransform: "uppercase",
      color: theme.whiteColor,
    },
    "&:hover > a": {
      color: theme.lightCoralColor,
    },
  },
  menuContainer: {
    "& > div": {
      cursor: "default",
    },
  },
}));

export default useStyles;
